module.exports = __webpack_public_path__ + "static/media/img_22.454b2419.png";